import styled from 'styled-components';

export const StyledAccessReasonCell = styled.span`
   /* stylelint-disable-next-line value-no-vendor-prefix */
   display: -webkit-box;
   /* stylelint-disable-next-line property-no-vendor-prefix */
   -webkit-line-clamp: 2;
   line-clamp: 2;
   /* stylelint-disable-next-line property-no-vendor-prefix */
   -webkit-box-orient: vertical;
   overflow: hidden;
   line-height: 18px;
   max-height: 36px;
`;

StyledAccessReasonCell.displayName = 'StyledAccessReasonCell';
